export { default as ProductInTable } from "./ProductInTable";
